import { render, staticRenderFns } from "./ResultTurnitin.vue?vue&type=template&id=74bb0bac"
import script from "./ResultTurnitin.vue?vue&type=script&lang=js"
export * from "./ResultTurnitin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports